export const COMPS_MAP_MAPBOX_ID = 'comps-map-mapbox'
